// Write mode is only chosen explicitly from the open menu; any other path falls back to the
// app's openAsReadOnlyByDefault property.
export const readOnlyOrAppDefault = (readOnly?: boolean): true | undefined =>
  readOnly ? true : undefined
